/* eslint-disable no-restricted-syntax */
/* eslint-disable no-cond-assign */
// Tables that list ingredients beside the method (Essential Mosimann) give every amount twice,
// "500 g (18 oz)". The bracketed measure is the same quantity in the other system, so it must not
// make the recipe look mixed. Lists are left alone: there a bracketed measure is a deliberate mix.
const BRACKETED_MEASURE = /(<\/measure>\s*)\(\s*<measure>[\s\S]*?<\/measure>\s*\)/gi;

const withoutBracketedTableMeasures = ingredient =>
  /<table[\s>]/i.test(ingredient) ? ingredient.replace(BRACKETED_MEASURE, '$1') : ingredient;

export default function checkMeasurementSystem({ ingredients, ingredientsListUnits = [] }) {
  let foundUS = false;
  let foundMetric = false;

  const lowerCaseUnits = (ingredientsListUnits || []).map(unit => unit.toLowerCase());

  if (lowerCaseUnits.includes('metric') && !lowerCaseUnits.includes('us')) {
    return 'onlyMetric';
  } else if (lowerCaseUnits.includes('us') && !lowerCaseUnits.includes('metric')) {
    return 'onlyUs';
  }

  if (!ingredients) {
    return 'neither';
  }

  for (const rawIngredient of ingredients) {
    const ingredient = withoutBracketedTableMeasures(rawIngredient);
    const regex = /system="([^"]*)"/gi;
    let match;
    while ((match = regex.exec(ingredient)) !== null) {
      const systems = match[1].toLowerCase().split(',');
      if (systems.includes('us')) {
        foundUS = true;
      }
      if (systems.includes('metric')) {
        foundMetric = true;
      }
    }
  }

  if (foundUS && foundMetric) {
    return 'both';
  } else if (foundUS) {
    return 'onlyUs';
  } else if (foundMetric) {
    return 'onlyMetric';
  }
  return 'neither';
}
